import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title w-100 m-0" }
const _hoisted_4 = { class: "d-flex w-100 align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ms-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Input Berita")
], -1)
const _hoisted_6 = { class: "ms-auto" }
const _hoisted_7 = {
  class: "btn btn-primary ps-2 pe-3 py-3",
  type: "button"
}
const _hoisted_8 = { class: "svg-icon svg-icon-2 me-0" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Multiple Input ")
const _hoisted_10 = { class: "card-body border-top p-9" }
const _hoisted_11 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Berhasil!", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Berita berhasil ditambahkan", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("u", null, "Lihat Berita", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "d-flex align-items-center gap-2" }
const _hoisted_19 = {
  key: 0,
  class: "col-sm-12 col-md-6 col-lg-6"
}
const _hoisted_20 = {
  class: "d-flex align-items-center gap-2 mx-5 mt-3 mb-2 text-primary",
  style: {"font-size":"14px"}
}
const _hoisted_21 = { class: "d-flex align-items-center gap-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "custom-divider-up mb-4" }, null, -1)
const _hoisted_23 = { class: "col-md-12 mb-4" }
const _hoisted_24 = { class: "d-flex justify-content-end" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle ml-2 fs-4" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Batalkan ")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["data-bs-toggle", "title"]
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle ml-2 fs-4" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Simpan Data ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}

import { IMedkon } from "@/global-helper/data-structure";
import { ref, watchEffect, computed, shallowRef, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { useRouter } from "vue-router";
import type { FormInstance } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { changeScraperNews } from "./streams";
import { API_DATE_TIME_FORMAT, formatDateTime } from "@/global-helper/handler";

// Variables

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const rule_form_ref = ref<FormInstance>();
const is_show_alert = ref(false);
const inserted_id = ref("");

const form = ref<any>({
  id: "",
  source: "media_cetak",
  title: "",
  account: "",
  program: "",
  content: "",
  date: "",
  emotion: "",
  file_source: { new: [] },
  journalist: "",
  page: "",
  rate_bw: "",
  rate_fc: "",
  sentiment: null,
  is_news_photo: "",
  ad_value: 0,
  rate_perdetik: 0,
  ppn: 0,
  duration: 0,
  jenis_data: "",
  bw_coloumn: 0,
  bw_width: 0,
  bw_volume: 0,
  bw_rate_ad: 0,
  bw_ad_value: 0,
  fc_coloumn: 0,
  fc_width: 0,
  fc_volume: 0,
  fc_rate_ad: 0,
  fc_ad_value: 0,
});

(window as any).formX = form;

const is_disable_save = computed(() => {
  if (form.value.source == "media_cetak") {
    if(form.value.bw_ad_value == 0 && form.value.fc_ad_value == 0) {
      return true;
    } else {
      return false;
    }
  } else if (form.value.source == "media_tv") {
    if(form.value.ad_value == 0) {
      return true;
    } else {
      return false;
    }
  } else if (form.value.source == "news") {
    return false;
  } else if (form.value.source == "radio") {
    if(form.value.ad_value == 0) {
      return true;
    } else {
      return false;
    }
  } else if (form.value.source == "running_text") {
    if(form.value.ad_value == 0) {
      return true;
    } else {
      return false;
    }
  }
});

const sources = ref([
  { value: "news", label: "Media Online", icon: "fas fa-pager" },
  { value: "media_cetak", label: "Media Cetak", icon: "far fa-newspaper" },
  { value: "media_tv", label: "Media TV", icon: "fas fa-tv" },
  { value: "radio", label: "Radio", icon: "bi bi-broadcast-pin" },
  { value: "running_text", label: "Running Text", icon: "bi bi-card-text" },
]);


const news_type = ref<any>([])

const component_form = shallowRef<any>(null);
const refreshupload = ref(false);

const cancelAction = () => {
  router.push({ name: "berita" });
};

const save_form = (formEl: FormInstance | undefined) => {
  if (!formEl) {
    Swal.fire({
      position: "top-end",
      icon: "error",
      toast: true,
      title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
      showConfirmButton: false,
      timer: 3000,
    });
  } else {
    formEl.validate((valid) => {
      if (valid) {
        dataLocalStorage('set-value');
        
        saveData(formEl);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
    });
  }
};

const saveData = async (formEl: FormInstance | undefined) => {
  if (form?.value?.is_scraper_edit) {
    const data = {
      title: form.value.title,
      content: form.value.content,
      account: form.value.account,
      date: formatDateTime(form.value.date),
      journalist: form.value.journalist,
    };
    const changes_value = await changeScraperNews(form.value.id, data);
    if (
      changes_value["message"] == "Berhasil" ||
      changes_value["message"] == "Nochanges"
    ) {
      Swal.fire({
        icon: "success",
        title: "Berhasil! Berita berhasil disimpan",
        confirmButtonText: "Ok",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-light-primary",
        },
      });
      
      const data_to_form: any  = JSON.parse(localStorage.getItem('data_berita') || JSON.stringify({}))
      form.value.source = data_to_form.source

      dataLocalStorage('get-value');
    } else {
      Swal.fire({
        icon: "error",
        title: "Gagal! Berita gagal disimpan",
        confirmButtonText: "Ok",
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-light-primary",
        },
      });
    }
  } else {
    if ("is_scraper_edit" in form.value) {
      delete form.value.is_scraper_edit;
    }

    if (form.value.source === "media_cetak") {
      // ganti format tanggal 
      const date = formatDateTime(form.value.date, API_DATE_TIME_FORMAT);

      // For rubrics API call
      const rubrics = await ApiService.get(
        `streams/generate-rubrics?date=${encodeURIComponent(date)}&account=${encodeURIComponent(form.value.account)}&page=${encodeURIComponent(form.value.page)}`
      )
        .then((response) => {
          return response.data || [];
        })
        .catch((error) => {
          console.error('Error fetching rubrics:', error);
          return [];
        });

      const formPages = typeof form.value.page === "string"
        ? form.value.page.split(",").map(p => p.trim())
        : form.value.page;

      // Cari page yang tidak ada di rubrics
      const pagesWithoutRubric = formPages.filter((page) => {
        return !rubrics.rubrics.some((rubric) => rubric.page === page && rubric.name !== '');
      });

      // tambahkan rubrics ke form.value
      form.value.rubrics = rubrics.rubrics;

      if (pagesWithoutRubric.length > 0) {

        const confirmation = await Swal.fire({
          title: "Konfirmasi",
          text: "Berita Halaman " + pagesWithoutRubric.join(", ") + " tidak memiliki rubrik. Apakah Anda yakin ingin melanjutkan?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Ya, Simpan",
          cancelButtonText: "Batal",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-secondary"
          }
        });

        if (confirmation.value !== true) {
          return;
        }
      }
    }

      const payload = mappingPayload(form.value);

      ApiService.sendPayload(payload.type, payload.base_api, {
        data: payload.data_payload,
      })
        .then((response) => {
          inserted_id.value = response.data.inserted_id;

          is_show_alert.value = true;
          setTimeout(() => {
            is_show_alert.value = false;
          }, 30000);

          formEl.resetFields();
          refreshupload.value = true;
          form.value.source = "media_cetak";

          Swal.fire({
            title: "Berita Berhasil Ditambahkan!",
            icon: "success",
            confirmButtonText: "Ok",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-light-primary",
            },
          });

          const data_to_form: any = JSON.parse(localStorage.getItem('data_berita') || JSON.stringify({}))
          form.value.source = data_to_form.source
          dataLocalStorage('get-value');

          setTimeout(() => {
            refreshupload.value = false;
          }, 200);
        })
        .catch((error) => {
          Swal.fire({
            title: "Gagal!",
            text: `${error.response.data.message
              ? error.response.data.message
              : error.response.data.detail.message
                ? error.response.data.detail.message
                : "Terjadi kesalahan saat menyimpan berita"
              }`,
            icon: "error",
            confirmButtonText: "Ok",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-light-primary",
            },
          });
        });
  }
};

const showDetail = () => {
  window.open("/berita/detail/" + inserted_id.value);
};

const resetForm = () => {
  form.value = {
    id: "",
    source: "media_cetak",
    title: "",
    account: "",
    program: "",
    content: "",
    date: "",
    emotion: "",
    file_source: { new: [] },
    journalist: "",
    page: "",
    rate_bw: "",
    rate_fc: "",
    sentiment: null,
    is_news_photo: "",
    ad_value: 0,
    rate_perdetik: 0,
    ppn: 0,
    duration: 0,
    jenis_data: "",
    bw_coloumn: 0,
    bw_width: 0,
    bw_volume: 0,
    bw_rate_ad: 0,
    bw_ad_value: 0,
    fc_coloumn: 0,
    fc_width: 0,
    fc_volume: 0,
    fc_rate_ad: 0,
    fc_ad_value: 0,
  };
};

// Function
function mappingPayload(data: any) {
  // template payload
  let base_api = "";
  let type = "post";
  let data_payload: any = {
    source: data.source,
    title: data.title,
    account: data.account,
    date: formatDateTime(data.date),
    journalist: data.journalist || '',
    sentiment: data.sentiment,
    content: data.content,
    jenis_data: data.jenis_data,
  };

  // add template payload by source
  if (data.source === "media_cetak") {
    base_api = "streams/media-cetak/add";

    data_payload.is_news_photo = data.is_news_photo;
    data_payload.page = data.page;
    data_payload.column_bw = data.bw_coloumn;
    data_payload.wide_bw = data.bw_width;
    data_payload.volume_bw = data.bw_volume;
    data_payload.rate_bw = data.bw_rate_ad;
    data_payload.ad_value_bw = data.bw_ad_value;
    data_payload.column_fc = data.fc_coloumn;
    data_payload.wide_fc = data.fc_width;
    data_payload.volume_fc = data.fc_volume;
    data_payload.rate_fc = data.fc_rate_ad;
    data_payload.ad_value_fc = data.fc_ad_value;
    data_payload.rubrics = data.rubrics;

    const file = [];
    if (data.file_source.new.length > 0) {
      data.file_source.new.forEach((item) => {
        file.push(item);
      });
    }

    data_payload.file_source = file;
  } else if (data.source === "media_tv") {
    base_api = "streams/media-tv/add";
    data_payload.program = data.program;
    data_payload.duration = data.duration;
    data_payload.rate_per_second = data.rate_perdetik;
    data_payload.ad_value = data.ad_value;

    const file = [];
    if (data.file_source.new.length > 0) {
      data.file_source.new.forEach((item) => {
        file.push(item);
      });
    }

    data_payload.file_source = file;
  } else if (data.source === "news") {
    if (data.id != "") {
      type = "put";
      base_api = `streams/onlinenews/update/${data.id}`;
    } else {
      base_api = "streams/onlinenews/add";
    }

    data_payload.ad_value = data.ad_value;
    data_payload.file_source = data.file_source;
  } else if (data.source === "radio") {
    base_api = "streams/radio/add";
    data_payload.program = data.program;
    data_payload.duration = data.duration;
    data_payload.rate_per_second = data.rate_perdetik;
    data_payload.ad_value = data.ad_value;

    const file = [];
    if (data.file_source.new.length > 0) {
      data.file_source.new.forEach((item) => {
        file.push(item);
      });
    }

    data_payload.file_source = file;
  } else if (data.source === "running_text") {
    base_api = "streams/running-text/add";
    data_payload.duration = data.duration;
    data_payload.rate_per_second = data.rate_perdetik;
    data_payload.ad_value = data.ad_value;

    const file = [];
    if (data.file_source.new.length > 0) {
      data.file_source.new.forEach((item) => {
        file.push(item);
      });
    }

    data_payload.file_source = file;
  }

  return { type, base_api, data_payload };
}

function dataLocalStorage(type) {
  if (type == 'set-value') {
    const dataform: any = mappingPayload(form.value);
    const datalocal = {
      ...(dataform.data_payload.source ? { source: dataform.data_payload.source } : {}),
      ...(dataform.data_payload.account ? { account: dataform.data_payload.account } : {}),
      ...(dataform.data_payload.journalist ? { journalist: dataform.data_payload.journalist } : {}),
      ...(dataform.data_payload.program ? { program: dataform.data_payload.program } : {}),
    }

    localStorage.setItem("data_berita", JSON.stringify(datalocal));
  } else if (type == 'get-value') {
    const data_to_form: any  = JSON.parse(localStorage.getItem('data_berita') || JSON.stringify({}))

    if (data_to_form.source == form.value.source) {
      form.value.source = data_to_form.source
      form.value.account = data_to_form.account || ""
      form.value.journalist = data_to_form.journalist || ""
      form.value.program = data_to_form.program || ""
    } else {
      form.value.account = ""
      form.value.journalist = ""
      form.value.program = ""
    }
  }
}

function getDataOptionsType(key) {
  const params: any = {
    ...(key ? {key} : {}),
    ...(form.value.source ? { source: form.value.source} : {}) 
  }

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  ApiService.get(`/options/news-type?${query}`)
  .then((response) => {
    news_type.value = response.data.news_type_data;
  })
  .catch((error) => {
    news_type.value = [];
  });
}

function checkSource(source) {
  const result = sources.value.find((el: any) => el.value === source);

  return result;
};

// Life Hook
watchEffect(async () => {
  if (form.value.source) {
    try {
      const component = (
        await import(`../berita/medkon/form_${form.value.source}.vue`)
      ).default;
      component_form.value = component;

      if (form.value.source === "media_cetak") {
        form.value.file_source = { old: [], new: [] };
      } else if (form.value.source === "media_tv") {
        form.value.file_source = { old: [], new: [] };
      } else if (form.value.source === "news") {
        form.value.file_source = "";
      } else if (form.value.source === "radio") {
        form.value.file_source = { old: [], new: [] };
      }

      dataLocalStorage('get-value');
      form.value.jenis_data = "";
      getDataOptionsType("");
    } catch (error) {
      component_form.value = null;
    }
  } else {
    component_form.value = null;
  }
});

onMounted(() => {
  setCurrentPageBreadcrumbs("Input Berita", ["Berita"]);

  getDataOptionsType("");
});

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (form.value.source === 'news')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "/berita/formed-add-bulk",
                  class: "ms-3"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
                      ]),
                      _hoisted_9
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_form, {
      model: form.value,
      ref: (_value, _refs) => {
        _refs['rule_form_ref'] = _value
        rule_form_ref.value = _value
      },
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          (is_show_alert.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _createElementVNode("a", {
                  class: "fw-bold ms-2",
                  style: {"cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showDetail()))
                }, _hoisted_16),
                _createElementVNode("i", {
                  class: "bi bi-x ms-auto text-danger",
                  style: {"font-size":"20px","cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (is_show_alert.value = false))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: _normalizeClass(`col-sm-12 ${news_type.value.length > 0 ? 'col-md-6 col-lg-6' : 'col-md-12 col-lg-12'}`)
            }, [
              _createVNode(_component_el_form_item, {
                label: "Sumber Berita",
                prop: "source",
                rules: {
                required: true,
                message: 'Sumber Berita Wajib Diisi',
                trigger: ['blur', 'change'],
              }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "form-control-custom",
                    modelValue: form.value.source,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.source) = $event)),
                    filterable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: source.value,
                          label: source.label,
                          value: source.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_18, [
                              _createElementVNode("i", {
                                class: _normalizeClass(source.icon)
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(source.label), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ], 2),
            (news_type.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_el_form_item, {
                    label: "Jenis Berita",
                    prop: "jenis_data",
                    rules: {
                required: news_type.value.length > 0 ? true : false,
                message: 'Jenis Berita Wajib Diisi',
                trigger: ['blur', 'change'],
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.value.jenis_data,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.jenis_data) = $event)),
                        class: "form-control-custom",
                        placeholder: "Pilih Jenis Berita",
                        remote: "",
                        "remote-method": getDataOptionsType
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news_type.value, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: group._id
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(`${checkSource(group.source).icon}`),
                                    style: {"font-size":"14px"}
                                  }, null, 2),
                                  _createTextVNode(" " + _toDisplayString(checkSource(group.source).label), 1)
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.types, (type) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: type.name,
                                    label: type.name,
                                    value: type.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_21, _toDisplayString(type.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["rules"])
                ]))
              : _createCommentVNode("", true),
            (_unref(component_form))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component_form)), {
                  key: 1,
                  form: form.value,
                  type: "add",
                  refreshupload: refreshupload.value
                }, null, 8, ["form", "refreshupload"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-4",
                onClick: cancelAction
              }, _hoisted_27),
              _createElementVNode("span", {
                "data-bs-toggle": _unref(is_disable_save) ? 'tooltip' : '',
                title: _unref(is_disable_save) ? 'Mohon Isikan AD Value' : ''
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (save_form(rule_form_ref.value))),
                  class: "btn btn-success",
                  disabled: _unref(is_disable_save)
                }, _hoisted_32, 8, _hoisted_29)
              ], 8, _hoisted_28)
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_unref(is_disable_save))
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, " ** Mohon inputkan " + _toDisplayString(form.value.source == "media_cetak" ? 'salah satu' : '') + " AD Value, nilai tidak boleh 0 ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})